import { z } from 'zod';

/**
 * Defines the schema for the client-side environment variables.
 * Using Zod ensures that the environment variables are correctly typed and that
 * the application fails fast if they are missing or invalid.
 */
const envSchema = z.object({
  VITE_APP_ID: z.enum(['dms', 'platform']).default('dms'),
  VITE_APP_NAME: z.string().default('Pill Connect DMS'),
  VITE_APP_SHORT_NAME: z.string().default('Pill Connect'),
  VITE_API_BASE_URL: z
    .string()
    .min(1, 'VITE_API_BASE_URL is required in your .env file.')
    .url('VITE_API_BASE_URL must be a valid URL.'),
  VITE_SENTRY_DSN: z.string().url().optional().or(z.literal('')),
  VITE_DISABLE_ANALYTICS: z
    .string()
    .optional()
    .transform((val) => val === 'true'),
  VITE_APP_ENV: z
    .enum(['development', 'preview', 'staging', 'production'])
    .optional()
    .default('development'),
});

const parsedEnv = envSchema.safeParse(import.meta.env);

if (!parsedEnv.success) {
  // Log the detailed error to the developer console
  console.error('❌ Invalid environment variables:', parsedEnv.error.format());

  // Throw a user-friendly error to stop the application from running
  throw new Error(
    'Invalid environment variables. Please check your .env file and restart the server.'
  );
}

// Export the validated and typed environment variables for use throughout the app
export const env = parsedEnv.data;
